import styled from 'styled-components';

import Link from 'components/link';

export const TermsLink = styled(Link)``;

export const OptInLabel = styled.span`
  display: block;
`;
